var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"order-items-view-container",attrs:{"fluid":""}},[_c('h1',[_vm._v("Order Items")]),_vm._v(" "),_c('order-items-table',{attrs:{"order-items":_vm.orderItems,"order-items-pagination":_vm.orderItemsPagination,"loading":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba45eff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/baader/OrderItems.vue
// module id = null
// module chunks = 